<template>
  <div class="login">
    <div class="content" v-loading="guestCheckoutLoading">
      <p class="top-titles">{{ $t('new_customer') }}</p>
      <div class="guest-head">
        <p class="guest-txt bold">{{ $t('save_time_now') }}</p>
        <p class="guest-txt">{{ $t('option_to_register') }}</p>
        <p class="guest-txt">{{ $t('create_a_account') }}</p>
      </div>
      <div class="input_box input_box_top">
        <span style="margin-left: 20px">{{ $t("email") }}</span>
        <p class="input_error_msg" v-if="this.guestCheckoutErrors.length">{{this.guestCheckoutErrors[0]}}</p>
        <el-input
          :class="[(this.guestCheckoutErrors.length && guestCheckoutForm.username) ? 'el-input-error' : 'el-input']"
          v-model="guestCheckoutForm.username"
          :placeholder="[this.guestCheckoutErrors.length ? this.guestCheckoutErrors[0] : $t('enter_email_address')]"
        ></el-input>
      </div>
      <div class="button-center">
        <button @click="guestLogIn">{{ $t('guest_checkout') }}</button>
      </div>
      <div class="guest-account">
        <p>
        <span @click="toggleLogIn">{{$t('login')}}</span> or <span @click="toggleRegister">{{ $t("register") }}</span>
        </p>
    </div>
    </div>
    <div class="close-modal">
      <img
        @click="toggleGuestCheckoutVisiblity(false)"
        src="../assets/img/closemodal.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import moment from 'moment';
import { isUserAuthenticated } from "../store/modules/cart";
export default {
  name: "guestCheckout",
  data() {
    return {
      guestCheckoutForm: {
        username: '',
        password: ''
      },
      guestCheckoutErrors: [],
      guestCheckoutLoading: false,
      guestCheckoutSuccess: false,
    }
  },
  methods: {
    ...mapMutations('orders', ['toggleOrderModal']),
    ...mapMutations('navbar', ['toggleLoginModalVisibility', 'toggleRegisterModalVisibility', 'toggleGuestCheckoutVisiblity', 'toggleWarehouseSelectionModalVisibility']),
    ...mapActions('auth', ['checkUsernameReturn', 'guestCheckout', 'LoginRequest']),
    guestLogIn() {
      this.guestCheckoutLoading = true;
      let that = this;
      const emailBeenTaken = this.checkUsernameReturn({ username: this.guestCheckoutForm.username })
      .then( (response) => {
        if (!response.data.isTaken) {
          let data = {email: this.guestCheckoutForm.username, username: this.guestCheckoutForm.username}
          this.guestCheckout(data)
          .then( (res) => {
            this.guestCheckoutLoading = false;
            this.LoginRequest({username: this.guestCheckoutForm.username, password: res.data });
          })
          .catch( (err) => {
            if (err.response.data.username) {
              if (Array.isArray(err.response.data.username)) {
                err.response.data.username.map(error => {
                  this.guestCheckoutErrors.push(error)
                });
              } else {
                this.guestCheckoutLoading = false;
                this.guestCheckoutErrors.push(err.response.data.username)
              }
            } else {
              this.guestCheckoutLoading = false;
              this.guestCheckoutErrors.push(err);
            }
          });
        } else {
          this.guestCheckoutLoading = false;
          if (!this.guestCheckoutErrors.includes('You have previously placed an order with this email. Please sign in or reset this password.')) {
            this.guestCheckoutErrors.push('You have previously placed an order with this email. Please sign in or reset this password.')
          }
        }
      })
    },
    resetForm() {
      this.guestCheckoutForm = { username: '', password: '' };
    },
    exitGuestCheckout() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(true);
    },
    toggleLogIn() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleRegisterModalVisibility(false);
      this.toggleLoginModalVisibility(true);
    },
    toggleRegister() {
      this.toggleGuestCheckoutVisiblity(false);
      this.toggleLoginModalVisibility(false);
      this.toggleRegisterModalVisibility(true);
    },
  },
  mounted() {
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch("cart/getCart");
      this.$store.dispatch("auth/fetchCustomerInformation");
    } else {
      // this.$store.dispatch("cart/fetchCartProducts");
      // this.$store.dispatch("auth/fetchCustomerInformation");
    }
    next();
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    userDetails: state => state.auth.userDetails,
    guestCheckoutModalVisiblity: state => state.navbar.guestCheckoutModalVisiblity,
    cartProductsList: state => state.cart.cartProductsList,

  }),
  watch: {
    loggedIn: function(newVal, oldVal) {
      if (newVal === true) {
        this.toggleGuestCheckoutVisiblity(false);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/css/guestCheckoutModal.less";
</style>



// WEBPACK FOOTER //
// src/view/guestCheckout.vue